var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.color && _vm.color.name)?_c('tooltip',{attrs:{"position":"top","tip":_vm.label + ': ' + _vm.color.name}},[_c('img',{attrs:{"src":_vm.image,"alt":_vm.label + ': ' + _vm.color.name}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }